import { render } from "./Home_default.vue?vue&type=template&id=4b4040c5&scoped=true"
import script from "./Home_default.vue?vue&type=script&lang=js"
export * from "./Home_default.vue?vue&type=script&lang=js"

import "./Home_default.vue?vue&type=style&index=0&id=4b4040c5&scoped=true&lang=css"

import exportComponent from "D:\\pro\\node-workspace\\machitabi_Vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4040c5"]])

export default __exports__